// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__MQu4U","compact":"Loading_compact__bHBZx","loader":"Loading_loader__xIpv6","xs":"Loading_xs__TKCkI","spin":"Loading_spin__XfZ33"};